const Home = () => {
  return (
    <section className="hero is-fullheight-with-navbar has-background-link-light FrontPage is-mobile">
      <div className="hero-body">
        <div className="container">
          <h1 className="title has-text-centered has-text-danger TitleText">
            Welcome to Heaven
          </h1>
          <h2 className="sub-title has-text-centered SubtitleText is-italic">
            Have a look around...
          </h2>
        </div>
      </div>
    </section>
  );
};

export default Home;
